import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['flash', 'flashContent', 'textInputField']

  displayFlash(state, message){
    this.toggleFlash(true)
    // this.flashContentTarget.className = ""
    this.flashContentTarget.classList.add("state--" + state)
    this.flashContentTarget.innerHTML = message
  }

  toggleFlash(show = false){
    show ? this.flashTarget.classList.remove("hidden") : this.flashTarget.classList.add("hidden")
  }

  isRequired(){
    return this.element.dataset.required == "true"
  }

  limitSelection() {
    return this.element.dataset.limitSelection == "true"
  }

  minSelection() {
    return this.limitSelection() && this.validRangeOption("minSelection") ? parseInt(this.element.dataset.minSelection) : null
  }

  maxSelection() {
    return this.limitSelection() && this.validRangeOption("maxSelection") ? parseInt(this.element.dataset.maxSelection) : null
  }

  validRangeOption(dataAttribute) {
    return (dataAttribute in this.element.dataset) && !isNaN(parseInt(this.element.dataset[dataAttribute]))
  }

  blankAnswer() {
    return this.textInputFieldTarget.value.length == 0
  }

  validateForm(){
    if(this.isRequired() && this.hasTextInputFieldTarget && this.blankAnswer()) {
      this.displayFlash("danger", "Please add an answer for this question.")
      return false
    }

    return true
  }

  prepare_submit(event) {
    console.log("prepare to submit......")
    event.preventDefault()
    if (this.validateForm()) {
      document.dispatchEvent(new Event("question-controller::validated"))
      // $(this.element).trigger("question-controller::validated")
    }
  }
}
